import React, { useEffect, useState } from 'react';

const ScrollChevrons = ({ elRef }) => {
	const [showChevrons, setShowChevrons] = useState(true);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setShowChevrons(false);
					if (elRef.current) {
						elRef.current.classList.add('scrollChevronTargetBounce');
						setTimeout(() => {
							elRef.current?.classList.remove('scrollChevronTargetBounce');
						}, 350);
					}
				} else {
					setShowChevrons(true);
				}
			},
			{
				threshold: 0.6,
			}
		);

		if (elRef.current) observer.observe(elRef.current);
		return () => observer.disconnect();
	}, [elRef]);

	const scrollToBtn = () => {
		elRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<div className="scrollChevronsContainer">
			{showChevrons && (
				<button type="button" className="chevrons" onClick={scrollToBtn}>
					<span className="chev" />
					<span className="chev" />
					<span className="chev" />
				</button>
			)}
		</div>
	);
};

export default ScrollChevrons;
